import type { FaireProductEntity } from "../../entity_types/product";

export const p_2t8khm78ub: FaireProductEntity = {
  token: "p_2t8khm78ub",
  type: "product",
  name: "Mountain Valley Plastic (500ml)",
  brandToken: "b_9z8pu8jvce",
  brandName: "Rising Sun Distributors",
  imageUrl:
    "https://cdn.faire.com/fastly/34deec7361c9ac8316c1d52d10ef376c2e8e411a4ffb81aa9b50d3430f452002.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.15,
  description:
    "Bring your customers a premium hydration experience with America’s most awarded spring water, bottled at the source in the Ouachita Mountains since 1871. Mountain Valley Spring Water is naturally alkaline with a crisp, refreshing taste that health-conscious shoppers love.",
  tags: [],
  msrpDollars: 4.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:31.998Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
